import * as React from 'react';
import { connect } from 'react-redux';
import { action } from 'ui/reducers/root';
import { IRootState } from 'ui/reducers/store';
import * as S from './style';
import { mixpanelService } from 'ui/utils/mixpanel';
import Tooltip from '@datashop/tooltip';
import { removeEmptyKeysFromObject } from 'patientCommons/utils/commons';
import { get } from 'lodash';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { IApps, getApps } from 'ui/utils/appsList';

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = typeof mapDispatchToProps;
type IProps = IStateProps & IDispatchProps & RouteComponentProps<{ empi: string }> & { visibleApps: string };

const Sidenav: React.SFC<IProps> = props => {
  const { visibleApps } = props;
  const appList = getApps(visibleApps);
  const scrollToTop = () => {
    const element = document.getElementById('overflow-content');
    if (element) {
      element.scrollTop = 0;
    }
  };

  const onClickHandler = (app: IApps) => {
    scrollToTop();
    props.setCurrentApp({ appName: app.name });
    props.setSidebarState({ set: 'open' });
    props.incrementAppsClickCount();
    (window as any).dispatchEvent(new CustomEvent('Patient-Sidenav-Close'));
    (window as any).dispatchEvent(new CustomEvent('DP360-Sidebar-Open'));
    const metaData = removeEmptyKeysFromObject({
      patient_id: props.match.params.empi,
      care_protocol_name: props.careProtocolName,
    });
    mixpanelService.track(`P360: DP360 - ${app.displayName} app clicked`, {
      ...metaData,
    });
  };

  return (
    <S.Wrapper isDP360Collapsed={props.isDP360Collapsed}>
      {appList.map(app => {
        return (
          <Tooltip key={app.name} tooltip={app.displayName} position="Left">
            <S.Element
              key={app.name}
              onClick={() => onClickHandler(app)}
              isSelected={!props.isDP360Collapsed && app.name === props.currentApp}
              data-test={app.testId}
            >
              <S.AppIcon name={app.icon} />
            </S.Element>
          </Tooltip>
        );
      })}
    </S.Wrapper>
  );
};

const mapStateToProps = (state: IRootState) => ({
  currentApp: state.sidebar.root.currentApp,
  isDP360Collapsed: state.sidebar.root.isDP360Collapsed,
  careProtocolName: get(state, 'care.careProtocol.details.data.name', ''),
});

const mapDispatchToProps = {
  setCurrentApp: action.setCurrentApp,
  setSidebarState: action.setSidebarState,
  incrementAppsClickCount: action.incrementAppsClickCount,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Sidenav));
